import { render, staticRenderFns } from "./Folders.vue?vue&type=template&id=5016ebf6&scoped=true&"
import script from "./Folders.vue?vue&type=script&lang=js&"
export * from "./Folders.vue?vue&type=script&lang=js&"
import style0 from "./Folders.vue?vue&type=style&index=0&id=5016ebf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5016ebf6",
  null
  
)

export default component.exports